<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <v-col cols="6" class="px-0 pr-1">
        <v-card height="170">
          <v-card-text>
            <v-container fluid class="pa-0" grid-list-xl>
              <v-layout>
                <v-flex>
                  <p class="title mb-1">{{ unitsTitle }}</p>
                  <label>{{ unitsLabel }}</label>
                  <mf-select-units-dialog
                    id="campaign-units"
                    :disable-save="isDisabled"
                    :selected-units.sync="unitsIdsErp"
                    outlined
                    dense
                    hide-ecommerce-configuration
                    :unit-error="errors.errorUnits"
                    :single-select="isDisabled"
                    :unavailable-units="unavailableUnits"
                    :units="units"
                    :tag-list="tagList"
                    :group-list="unitsGroups"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="px-0 pl-1">
        <v-card class="pa-4" height="170">
          <p class="title mb-1">Regras do sorteio</p>
          <input ref="rules-input" class="hidden-input" type="file" @input="readFile($event, 'rulesFile')" />
          <mf-button :label="rulesBtnLabel" :loading="rulesFile.isLoading" :disabled="isDisabled || rulesFile.isLoading" @click="uploadRules" />
          &nbsp;
          <span v-if="raffle.rules_url" class="file-chip">
            <mf-icon fill small color="marca-0">insert_drive_file</mf-icon>
            {{ rulesFileName }}
            <mf-icon v-if="raffle.status === 'DRAFT'" :disabled="isDisabled" :style="{ fontSize: '11px' }" icon="close" @click="deleteRules" />
          </span>
          <p v-if="errors.errorRules" class="error--text error-text my-2">{{ errors.errorRules }}</p>
          <p class="hint-text mt-2">Formato aceito: PDF. Limite de 10 MB.</p>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$getAllowedModules()['terms_optin']">
      <v-col cols="12" class="px-0">
        <v-card>
          <v-card-text>
            <p class="title mb-1">Termos do sorteio</p>
            <label>
              Este campo define se a aceitação dos termos do sorteio será obrigatória; se for, os clientes deverão aceitar um termo, e o texto deverá ser
              definido, e se não for, poderão participar sem essa exigência.
            </label>
            <mf-toggle v-model="raffle.optin.active" :disabled="isDisabled" label="Termo obrigatório" :value="raffle.optin.active" class="mt-2" />
            <p>Digite os termos abaixo</p>
            <v-textarea
              v-model="raffle.optin.terms"
              class="custom-textarea"
              :error="raffle.optin.active && errors.errorTermsOptin"
              :disabled="!raffle.optin.active || isDisabled"
              :error-messages="errors.errorTermsOptin"
              placeholder="Termos do sorteio no app"
              outlined
              no-resize
              rows="5"
              counter="10000"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'UnitsAndStartDate',
  props: {
    isDisabled: {
      type: Boolean,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    rulesFile: {
      type: Object,
      required: true,
    },
    readFile: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    unitsTitle: 'Lojas',
    unitsLabel: 'Lojas às quais o sorteio vai valer.',
    minDate: moment().tz('America/Bahia').toISOString(),
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    unitsIdsErp: {
      get() {
        if (this.raffle.units.length === 0) return this.raffle.units
        return this.raffle.units.map((unit) => unit.id_erp)
      },
      set(value) {
        this.raffle.units = value.map((unit) => ({ id_erp: unit }))
      },
    },
    unavailableUnits() {
      return this.isDisabled ? this.units.map((unit) => unit.id_erp) : []
    },
    hasRules() {
      return this.rulesFile.fileContent !== null
    },
    rulesBtnLabel() {
      return this.hasRules ? 'Alterar' : 'Selecionar'
    },
    rulesFileName() {
      let splitName = this.raffle.rules_url.split('/').pop().split('-')
      if (this.raffle.rules_url.split('/').length === 1) return this.raffle.rules_url
      return splitName.slice(5, splitName.length).join('-')
    },
  },
  mounted() {
    if (!this.raffle.optin) {
      this.$set(this.raffle, 'optin', {
        active: false,
        terms: '',
      })
    }
  },
  methods: {
    uploadRules() {
      this.$refs['rules-input'].value = null
      this.$refs['rules-input'].click()
    },
    deleteRules() {
      this.rulesFile = {
        ...this.rulesFile,
        file: null,
        fileName: '',
        fileType: null,
        fileUrl: null,
        fileContent: null,
      }
      this.raffle.rules_url = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden-input {
  display: none;
}
.error--text {
  font-size: 12px;
}
</style>
